<style scoped lang="sass">
.tab_dialog_container
  height: 100%
  width: 100%
  text-align: center

.button
  margin-top: 45px
  width: 100%
  height: 56px
  font-size: 15px

.pc_button
  width: 100%
  height: 56PX
  margin-top: 45PX
  font-size: 15PX

.icon
  height: 57px
  width: 57px
  margin: auto

.pc_icon
  width: 57PX
  height: 57PX
  margin: auto

.title
  margin-top: 24px
  margin-bottom: 13px
  font-size: 19px
  line-height: 1
  color: var(--menu-primary-text-colour)

.pc_title
  margin-top: 24PX
  margin-bottom: 13PX
  font-size: 19PX
  line-height: 1
  color: var(--menu-primary-text-colour)

.content
  line-height: 18px
  font-size: 15px
  white-space: pre-line
  color: var(--menu-primary-text-colour)

.pc_content
  line-height: 18PX
  font-size: 15PX
  white-space: pre-line
  color: var(--menu-primary-text-colour)

.second
  margin-top: 20px

.pc_second
  margin-top: 20PX

.pc_box
  padding: 15PX

::v-deep
  .is_mobile
    display: flex
    flex-direction: column
    width: 283px
    padding: 0 10PX
    padding-top: 10PX

  .van-button--primary
    background: var(--menu-primary-background-colour)
    border: none
    border-radius: 4PX !important

</style>

<template lang="pug">
.tab_dialog_container
  BottomPopupDialog.is_mobile(
    v-model="visible"
    :showCloseIcon="false"
    :position="'center'"
    v-on="$listeners"
    v-bind="$attrs"
  )
    template(v-slot:popup-dialog)
      img.icon(v-if="icon" :src="icon")
      .title.b(v-if="title") {{ title }}
      .content.o75(v-if="newContent") {{ newContent }}
      .content.second.o75(v-if="secContent") {{ secContent }}
      van-button.button.b(v-if="buttonText" type="primary" @click="clickHandler") {{ buttonText }}
</template>

<script>
import { Sticky } from 'vant'
import Vue from 'vue'
import Component from 'vue-class-component'
import resizeHandler from 'utils/resizeHandler'

export default {
  mixins: [resizeHandler],

  name: 'TabMessageDialog',

  props: {
    insertStr: String, // If a string needs to be inserted at a certain position in content, this variable will pass the content to be inserted   // 如果 content 中某个位置需要插入字符串，那么此变量就传递要插入的内容
    icon: [Object, String],
    title: String,
    content: String,
    buttonText: String,
    secContent: String,
  },

  computed: {
    newContent() {
      if (this.insertStr) {
        return this.content.replace('$insertStr', this.insertStr)
      }
      return this.content
    }
  },

  data() {
    return {
      visible: false,
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    hide() {
      this.visible = false
    },

    clickHandler() {
      this.visible = false
      this.$emit('click', this.isMobile)
    },
  }
}
</script>
